import { ButtonBase, Stack, useTheme } from "@mui/material";
import { Check } from "lucide-react";
import type { FC, ReactNode } from "react";

type Props = {
	checked: boolean;
	disabled?: boolean;
	onToggle: () => void;
	trailing?: ReactNode;
	children: ReactNode;
};

export const InspirationCheckRow: FC<Props> = ({
	checked,
	disabled = false,
	onToggle,
	trailing,
	children,
}) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="center"
			borderBottom={theme.colors.border.solid(theme.palette.grey[200])}
		>
			<ButtonBase
				role="checkbox"
				aria-checked={checked}
				disabled={disabled}
				onClick={onToggle}
				sx={{
					flex: 1,
					minWidth: 0,
					justifyContent: "flex-start",
					gap: theme.spacingTokens.md,
					py: theme.spacingTokens.md,
					textAlign: "left",
					opacity: disabled ? 0.5 : 1,
					"&:active": { bgcolor: theme.palette.grey[50] },
				}}
			>
				<Stack
					width={theme.iconSize.md}
					height={theme.iconSize.md}
					flexShrink={0}
					alignItems="center"
					justifyContent="center"
					borderRadius={theme.radii.sm}
					bgcolor={checked ? theme.palette.blue.main : "transparent"}
					border={
						checked
							? undefined
							: theme.colors.border.solid(theme.palette.grey[300])
					}
				>
					{checked && (
						<Check
							size={theme.iconSize.xs}
							color={theme.palette.darkmodeText.white}
						/>
					)}
				</Stack>
				{children}
			</ButtonBase>
			{trailing}
		</Stack>
	);
};
